/* eslint camelcase: "off" */

import Vue from 'vue'
import Vuex from 'vuex'
import accounts from './modules/accounts'
import alerts from './modules/alerts'
import applicants from './modules/applicants'
import applications from './modules/applications'
import auto_payments from './modules/auto-payments'
import bank_accounts from './modules/bank-accounts'
import bank_cards from './modules/bank-cards'
import blog_posts from './modules/blog-posts'
import businesses from './modules/businesses'
import calendar_events from './modules/calendar-events'
import callback_requests from './modules/callback-requests'
import charges from './modules/charges'
import chats from './modules/chats'
import contacts from './modules/contacts'
import documents from './modules/documents'
import email_verifications from './modules/email-verifications'
import errors from './modules/errors'
import fees from './modules/fees'
import hints from './modules/hints'
import identity_documents from './modules/identity-documents'
import inventories from './modules/inventories'
import invitations from './modules/invitations'
import job_sheets from './modules/job_sheets'
import landlords from './modules/landlords'
import listings from './modules/listings'
import maintenances from './modules/maintenances'
import messages from './modules/messages'
import notes from './modules/notes'
import notifications from './modules/notifications'
import occupants from './modules/occupants'
import password_resets from './modules/password-resets'
import payment_intents from './modules/payment-intents'
import payments from './modules/payments'
import payouts from './modules/payouts'
import persons from './modules/persons'
import preload from './modules/preload'
import properties from './modules/properties'
import remarketings from './modules/remarketings'
import rents from './modules/rents'
import residencies from './modules/residencies'
import search from './modules/search'
import sessions from './modules/sessions'
import setup_intents from './modules/setup-intents'
import subscriptions from './modules/subscriptions'
import tasks from './modules/tasks'
import tenancies from './modules/tenancies'
import tenants from './modules/tenants'
import transactions from './modules/transactions'
import transfers from './modules/transfers'
import users from './modules/users'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        accounts,
        alerts,
        applicants,
        applications,
        auto_payments,
        bank_accounts,
        bank_cards,
        blog_posts,
        businesses,
        calendar_events,
        callback_requests,
        charges,
        chats,
        contacts,
        documents,
        email_verifications,
        errors,
        fees,
        hints,
        identity_documents,
        inventories,
        invitations,
        job_sheets,
        landlords,
        listings,
        maintenances,
        messages,
        notes,
        notifications,
        occupants,
        password_resets,
        payment_intents,
        payments,
        payouts,
        persons,
        preload,
        properties,
        remarketings,
        rents,
        residencies,
        search,
        sessions,
        setup_intents,
        subscriptions,
        tasks,
        tenancies,
        tenants,
        transactions,
        transfers,
        users
    },
    strict: debug
})
